import React, { useState } from 'react'
import LineInput from '../../common/lineinput'
import { Box, Paper } from '@mui/material'
import { Item, SuccessPopUp, TableUI } from '../../common/snippets'
import Button from '@mui/material/Button'
import LineInputV2 from '../../common/lineinputV2'
import {
  BookingDeliveryDetailsUpdate,
  ConsignmentBookingChargesUpdate,
  updateModal,
  addNewRowModify,
  RemoveRowModify,
  updateAlert,
  updateModifyData,
  GetMOFPaymentUpdate,
} from '../../../store/common/common_action'
import { cargoGetRateForConsignment } from '../../../store/booking/booking_action'
import { connect } from 'react-redux'
import { useEffect } from 'react'
import { updatePriceSectData } from '../../../store/booking/booking_action'
import {
  focusElemnt,
  getConsignmentUpdateData,
  getFloat,
  getInt,
  getText,
  isNull,
  navigation1,
  updateObjArrayAtSpfcInd,
} from '../../common/helper'
import * as iid from '../../common/bookingElementId'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import { getConsignmentSectionForModify } from '../../common/constantsBooking'
import DropDownOA from '../../common/dropDownOA'
import { API_CACHE_DURATION, LIMIT_FOR_NON_EWAYBILLL_BOOKING, PARENT_COMPANY_MODE, UNIT_BILLED, WEIGHT_BILLED } from '../../common/constants'
import { useRef } from 'react'
import CollCartageUI from '../BookingActivity/CollCartageUI'
import VolumetricWeightUI from '../BookingActivity/VolumetricWeightUI'
import { CargoGetRateForConsignment } from '../../common/apiRequests/commonApiRequest'
import { updatePriceSectionRowData } from '../../../store/booking/booking_action'
import { getCargoSettingFilterData } from '../../../store/reports/reports_action'
import { useAtom } from 'jotai'
import { companyTaxAtom } from '../../common/jotaiState/bookingStateAtoms'
import { bookingGST, chargeFields } from '../../common/bookingHelper'
import { companySettingsAtom, gstConfigAtom } from '../../common/jotaiState/commonStateAtoms'
const ConsignmentBookingTab = (props) => {
  const {
    data,
    updateModal,
    updatePriceSectData,
    updatePriceSectionRowData,
    cargoGetRateForConsignment,
    addNewRowModify,
    RemoveRowModify,
    updateAlert,
    updateModifyData,
    ConsignmentBookingChargesUpdate,
    getCargoSettingFilterData,
  } = {
    ...props,
  }
  const {GetMOFPaymentUpdate} = props
  const { common, booking: bookingL, reports } = data
  let { priceSectionData, consignmntData } = { ...bookingL }
  const { cargoSettingFilterData } = reports
  const {
    loginData,
    cnsgnmntTypes,
    methodOfPckgTypes,
    ModifyData,
    ModifyData1=[],
    roleRights,
  } = { ...common }
  let { companyBookingPermission, parentCompnayData } = common
  const [CCR, setCCR] = useState('')
  const [cmnt, setCmnt] = useState('')
  const { citywiseBranchList,methodOfPayment } = common

  const [companySettings] = useAtom(companySettingsAtom)
  const [gstConfig] = useAtom(gstConfigAtom)
  const IsMultipleConsignment = companySettings?.IsMultipleConsignment
  const cnsgnmntSection = getConsignmentSectionForModify(IsMultipleConsignment)
  const OwnparentCompnayData = parentCompnayData.length ? parentCompnayData[PARENT_COMPANY_MODE] : {}
  const { ParentCompanyID } = OwnparentCompnayData

  const priceSection = [
    { label: 'Total Freight', type: 'text', id: 'freight', width: '9.3%', readOnly: true, value: props?.selectLr?.Freight },
    { label: 'Coll. Cartage', type: 'text', id: 'coll_cartage', width: '9.3%', value: props?.selectLr?.CartageAmount },
    { label: 'Drop Cartage', type: 'text', id: 'del_cartage', width: '9.3%', value: props?.selectLr?.CartageDeliveryAmount },
    { label: 'Hamali', type: 'text', id: 'hamali', width: '9.3%', value: props?.selectLr?.HamaliCharges },
    { label: 'Op Hamali', type: 'text', id: 'op_hamali', width: '9.3%', value: props?.selectLr?.OtherCharge },
    { label: 'Valuation', type: 'text', id: 'valuation', width: '9.3%', value: props?.selectLr?.Insurance },
    { label: 'Doc Fee', type: 'text', id: 'doc_fee', width: '9.3%', value: props?.selectLr?.DocumentCharges },
    { label: 'Pickup Fee', type: 'text', id: 'pickup_fee', width: '9.3%', value: props?.selectLr?.CollectionCharges },
    { label: 'Dropoff Fee', type: 'text', id: 'dropoff_fee', width: '9.3%', value: props?.selectLr?.HomeDeliveryChg },
    { label: 'GST', type: 'text', id: 'gst', width: '9.3%', value: props?.selectLr?.ServiceTaxAmount },
  ]
  const { selectLr } = props
  const [cmpnyTax] = useAtom(companyTaxAtom)
  const [priceSecList, setPriceSecList] = useState([...priceSection])
  const [removeIndex, setRemoveIndex] = useState(-1)
  const [addPopup, setAddPopup] = useState(false)
  const [delPopup, setDelPopup] = useState(false)
  const [collCartageModal, setCollCartageModal] = useState(false)
  const [volumetriModal, setVolumetriModal] = useState(false)
  const [selectedRowIndex, setSelectedRowIndex] = useState(0)
  const [slctdRwData, setSlctdRwData] = useState()
  const [SelectedConsignment, setSelectedConsignment] = useState()
  const [IsSharedChildCompany, setIsSharedChildCompany] = useState(0)
  const [additionalChrg, setAdditionalChrg] = useState('')
  const [methodOfPaymentData, setMethodOfPaymentData] = useState([])
  const [selectedMethod, setSelectedMethod] = useState()

  useEffect(() => {
    if (loginData) {
      const obj = {
        intCompanyID: loginData?.intCompanyID,
        intBranchID: loginData?.intBranchID,
        intUserID: loginData?.intUserID,
      }
      getCargoSettingFilterData(obj)
    }
  }, [loginData])
  useEffect(() => {
    setCCR(selectLr?.CartageRemarks)
    setCmnt(selectLr?.Remarks)
  }, [selectLr])
  useEffect(() => {
    setCollCartageModal(false)
    GetMOFPaymentUpdate({ intBranchID: loginData?.intBranchID }, true, API_CACHE_DURATION)
  }, [])
  useEffect(() => {
    if (methodOfPayment?.status === 'Success') {
      const filteredData = methodOfPayment?.Data?.Table?.filter((val) => ![2, 8].includes(val.ModeID))
      setMethodOfPaymentData(filteredData)
      if (selectLr?.ModeOfPayment) {
        setSelectedMethod(methodOfPayment?.Data?.Table.find((val) => val.ModeID === selectLr?.ModeOfPayment) || {})
      }
    } else {
      setMethodOfPaymentData([])
      setSelectedMethod('')
    }
  }, [methodOfPayment])
  useEffect(() => {
    const { IsCartage, IsDelCartage, IsHamali, IsOperatorHamali } = companySettings || {}
    const { IsInsurance, IsDocument, IsPickUpAndDropOffChg, DisableDocChg } = companySettings || {}
    const [{ DisablePickupCartage, DisableMiscellaneousCartage, DisableBookingDeliveryCartage }] = citywiseBranchList || []
    const {
      Table1: [{ AllowHamaliEdit, AllowOperatorHamaliEdit, AllowShowAdditional }],
    } = roleRights || {}
    const updatedpriceSection = [
      priceSection[0],
      { ...priceSection[1], readOnly: AllowShowAdditional === 0 || !IsCartage || DisablePickupCartage === 1 },
      { ...priceSection[2], readOnly: AllowShowAdditional === 0 || !IsDelCartage || DisableBookingDeliveryCartage === 1 },
      { ...priceSection[3], readOnly: AllowShowAdditional === 0 || !IsHamali || !AllowHamaliEdit },
      { ...priceSection[4], readOnly: AllowShowAdditional === 0 || !IsOperatorHamali || !AllowOperatorHamaliEdit },
      { ...priceSection[5], readOnly: AllowShowAdditional === 0 || !IsInsurance },
      { ...priceSection[6], readOnly: AllowShowAdditional === 0 || !IsDocument || ParentCompanyID === 10 || DisableDocChg === 1 },
      { ...priceSection[7], readOnly: AllowShowAdditional === 0 || !IsPickUpAndDropOffChg },
      { ...priceSection[8], readOnly: AllowShowAdditional === 0 || !IsPickUpAndDropOffChg },
      { ...priceSection[9], readOnly: true },
    ]
    setPriceSecList(updatedpriceSection)
  }, [companySettings, roleRights, ParentCompanyID, citywiseBranchList])
  function safeNumber(val) {
  let num = Number(val)
  return Number.isFinite(num) ? num : 0
}
useEffect(() => {
  if (ModifyData.length) {
    updatePriceSectData(
      'freight',
      ModifyData.reduce((p, c) => p + parseFloat(c.Freight || 0), 0)
    )
  }
}, [ModifyData])
useEffect(() => {
  if (ModifyData1?.length > 0) {
    updatePriceSectData('freight', ModifyData1[0]?.TotalFreight)
    updatePriceSectData('coll_cartage', ModifyData1[0]?.CollCartage)
    updatePriceSectData('del_cartage', ModifyData1[0]?.DeliveryCartage)
    updatePriceSectData('hamali', ModifyData1[0]?.HamaliCharges)
    updatePriceSectData('op_hamali', ModifyData1[0]?.OperatorHamaliChg)
    updatePriceSectData('valuation', ModifyData1[0]?.Insurance)
    updatePriceSectData('doc_fee', ModifyData1[0]?.DocumentCharges)
    updatePriceSectData('pickup_fee', ModifyData1[0]?.PickupCharge)
    updatePriceSectData('dropoff_fee', ModifyData1[0]?.DropOffCharge)
    updatePriceSectData('gst', ModifyData1[0]?.gst)
    updatePriceSectData('gross_amount', ModifyData1[0]?.NetAmount)
    updatePriceSectData('CCBrkup_cmsn', ModifyData1[0]?.CommCartage)
    updatePriceSectData('CCBrkup_pckp', ModifyData1[0]?.PickupCartage)
    updatePriceSectData('CCBrkup_rtrn', ModifyData1[0]?.ReturnCartage)
    updatePriceSectData('addiTionalChrg', ModifyData1[0]?.ConvenienceCharge)
    setAdditionalChrg(ModifyData1[0]?.ConvenienceCharge)
  }
}, [ModifyData1])
useEffect(() => {
  const taxableFreight = chargeFields.reduce((acc, field) => {
    acc += safeNumber(priceSectionData[field])
    return acc
  }, 0)
  let [taxgst, totalAmount] = bookingGST(gstConfig, priceSectionData, taxableFreight, cmpnyTax, companySettings?.FreightCartageOptHamali)
  if (ModifyData1 && safeNumber(ModifyData1[0]?.gst) !== 0) {
    if (ModifyData && ModifyData[0]?.SubType !== 'FTL') {
      updatePriceSectData('gst', taxgst)
    } else {
      taxgst = 0
      updatePriceSectData('gst', 0)
    }
  } else {
    taxgst = 0
    updatePriceSectData('gst', 0)
  }
  updatePriceSectData('GSTAmount', safeNumber(totalAmount))
  updatePriceSectData('gross_amount', safeNumber(taxableFreight) + safeNumber(taxgst))
}, [
  priceSectionData.freight,
  priceSectionData.coll_cartage,
  priceSectionData.del_cartage,
  priceSectionData.hamali,
  priceSectionData.op_hamali,
  priceSectionData.valuation,
  priceSectionData.pickup_fee,
  priceSectionData.dropoff_fee,
  priceSectionData.doc_fee,
])
  const collCartageRef = useRef(null)
  useEffect(() => {
    if (collCartageRef && collCartageRef.current && collCartageModal) {
      setTimeout(() => {
        focusElemnt(`CCBrkup_pckp`)
      }, 200)
    }
  }, [collCartageRef, collCartageModal])
  const VolumetricRef = useRef(null)
  useEffect(() => {
    if (VolumetricRef && VolumetricRef.current && volumetriModal) {
      setTimeout(() => {
        focusElemnt(`wt_vlm_len`)
      }, 200)
    }
  }, [VolumetricRef, volumetriModal])


  function cf(x) {
    //convert to float
    var floatValue = +x
    return floatValue
  }
  function getTax(Amount) {
  try {
    if (safeNumber(Amount) >= safeNumber(cmpnyTax?.MinTaxAmount) && safeNumber(cmpnyTax?.TaxPct) > 0) {
      return Math.round((safeNumber(Amount) * safeNumber(cmpnyTax?.TaxPct)) / 100)
    }
    return 0
  } catch (e) {
    return 0
  }
}
  const handlePriceSect = (e, key) => {
    if (key == 'coll_cartage' && companySettings?.HasCartageBreakup) return
    updatePriceSectData(key, +e.target.value)
  }
  const getPriceSectUI = (data, index, lastIndex = false) => {
    const { label, type = 'text', id, width = '9%', value, readOnly = false } = { ...data }
    const nextId = lastIndex ? 'updateConsignmentBookingCharge' : priceSection[index + 1].id
    const prevId = index === 0 || index === 1 ? 'frieght' : priceSection[index - 1].id
    return (
      <div className="priceSection" key={`price_sec_${id}_${label}`} style={{ width }}>
        <div className={'input--wrapper btmSpaceNotRequired'}>
          <LineInputV2
            id={id}
            type={type}
            name={id}
            label={label}
            // value={value ? value : 0}
            autoFocus={id === 'freight' ? true : false}
            value={priceSectionData[id]}
            disabled={readOnly}
            onBlur={(e) => {
              handlePriceSect(e, id)
            }}
            onFocus={() => {
              id == 'coll_cartage' && companySettings?.HasCartageBreakup ? setCollCartageModal(true) : setCollCartageModal(false)
            }}
            onKeyDown={(e) => navigation1(e, nextId, prevId)}
          />
        </div>
        <div className="plusSymbl">{lastIndex ? `=` : `+`}</div>
      </div>
    )
  }

  const UpdateBookingDeliveryCharges = () => {
    const totalGoodsValue = ModifyData.reduce((accumulator, current) => {
      const value = Number(current.GoodsValue) || 0
      return accumulator + value
    }, 0)
    if (totalGoodsValue >= LIMIT_FOR_NON_EWAYBILLL_BOOKING && !ModifyData1.EWayBillNo) {
      handleAlert(
        'E-Way Bill is mandatory for goods worth more then ' +
          LIMIT_FOR_NON_EWAYBILLL_BOOKING +
          ', Please Add E-Way Bill Update from action.'
      )
    } else {
      let updateData = getConsignmentUpdateData(ModifyData, priceSectionData, selectLr, ModifyData1, loginData, additionalChrg, CCR, cmnt, selectedMethod)
      ConsignmentBookingChargesUpdate(updateData, props.setOnClosePopup)
      updateModal()
      props.updateData() //To update data on list Screen
    }
  }
  const ShowConsignmentAddPopUp = () => {
    const data = {
      successMessage: 'Do you want to add a consginment',
      otherMessage: '',
      buttonId1: '',
      buttonId2: '',
      yesAction: () => {
        addNewRowModify()
        setAddPopup(false)
      },
      noAction: () => {
        setAddPopup(false)
        // focusElemnt(iid.collCartage)
      },
    }
    return <SuccessPopUp data={data} updateModal={updateModal} />
  }
  const ShowConsignmentDeletePopUp = () => {
    const data = {
      successMessage: 'do you want to remove consignment',
      otherMessage: '',
      buttonId1: '',
      buttonId2: '',
      yesAction: () => {
        setDelPopup(false)
        RemoveRowModify(removeIndex)
        // focusElemnt(iid.addRemove + removeIndex)
      },
      noAction: () => {
        setDelPopup(false)
        // focusElemnt(iid.addRemove + removeIndex)
      },
    }
    return <SuccessPopUp data={data} updateModal={updateModal} />
  }
  const handleAlert = (msg = false, nextId = '') => {
    if (typeof msg === 'string' && !isNull(msg)) {
      updateAlert({ show: true, msg, nextId })
    } else {
      updateAlert({ show: false, msg: '', nextId: '' })
      focusElemnt(nextId)
    }
  }
  const handleChange = (e, type) => {
    const { value } = e.target
    if (type === 'CCR') {
      setCCR(value)
    } else if (type === 'cmnt') {
      setCmnt(value)
    }
  }

  const getAllowedFareChangePercValue = (rate, limitOnFareChangePerc) => {
    return (rate * limitOnFareChangePerc) / 100
  }
  const calNupdateWtCharge = (slctdRwData, slctdRowIndex, updateCharge) => {
    let intQty = cf(slctdRwData.Quantity) || 0
    let intActWeight = slctdRwData.ActualWeight || 0
    let intMinAllUnitChargeWeight = slctdRwData?.slctdCnsgnmntType?.MinWeightAllUnits || 0
    let intMinPerUnitChargeWeight = slctdRwData?.slctdCnsgnmntType?.MinWeightPerUnit || 0

    let intCalChrgWeight = 0

    if (intMinPerUnitChargeWeight > 0) {
      intCalChrgWeight = intQty * intMinPerUnitChargeWeight
    } else {
      intCalChrgWeight = intMinAllUnitChargeWeight
    }
    const wtCharge = intCalChrgWeight < intActWeight ? intActWeight : intCalChrgWeight
    updateModifyData(slctdRowIndex, 'ChargedWeight', wtCharge)
    let bU = slctdRwData?.slctdCnsgnmntType?.BillingUnit
    let IsSharedChildCompany = 0
    const branchPermisson = (companyBookingPermission?.Table1 || []).filter(
      (el) => el.ParentCompanyID === ParentCompanyID && el.ChildCompanyID === loginData.intCompanyID
    )
    if (branchPermisson.length) IsSharedChildCompany = branchPermisson[0].IsSharedChildCompany
    if (ParentCompanyID === 10 && IsSharedChildCompany === 0 && slctdRwData?.slctdCnsgnmntType?.IsKgKm === 1) {
      bU = UNIT_BILLED
    }
    if (bU && [WEIGHT_BILLED, UNIT_BILLED].includes(bU)) {
      updateModifyData(slctdRowIndex, 'Freight', bU == UNIT_BILLED ? intQty * slctdRwData.Rate : slctdRwData.Rate * wtCharge)
    }
    return wtCharge
  }
  const ValidateUnitAndFreightTotal = (val, index, key, isF = false) => {
    let totalWt = updateObjArrayAtSpfcInd(ModifyData, index, key, val).reduce((p, c) => p + parseFloat(c[key] || 0), 0)
    return isF ? totalWt.toFixed(2) : totalWt
  }

  useEffect(() => {
    const branchPermisson = (companyBookingPermission?.Table1 || []).filter(
      (el) => el.ParentCompanyID === ParentCompanyID && el.ChildCompanyID === loginData?.intCompanyID
    )
    let IsSharedChildCompany = 0
    if (branchPermisson.length) IsSharedChildCompany = branchPermisson[0].IsSharedChildCompany
    setIsSharedChildCompany(IsSharedChildCompany)
  }, [companyBookingPermission])
  const hndlCnsgnmntRate = (slctdCnsgnmntType, slctdRwData, slctdRowIndex, updateCharge = false) => {
    let intIsExpress = 0
    const intConsignmentID = slctdCnsgnmntType?.ConsignmentSubTypeID !== undefined ? slctdCnsgnmntType.ConsignmentSubTypeID : 0,
      dcmActWeight = slctdRwData.ActualWeight > 0 ? slctdRwData.ActualWeight : 0,
      intIsPartySender = ModifyData1[0].IsPartySender,
      intPaymentTypeID = ModifyData1[0].PaymentTypeID,
      intPartyID = ModifyData1[0].SenderPartyID
    const wtCharge = calNupdateWtCharge(slctdRwData, slctdRowIndex, updateCharge)
    const rfcData = CargoGetRateForConsignment
    rfcData.intCompanyID = loginData?.intCompanyID
    rfcData.intFromCityID = ModifyData1[0].SourceCityID
    rfcData.intToCityID = ModifyData1[0].DestCityID
    rfcData.intConsignmentID = intConsignmentID
    rfcData.intIsExpress = intIsExpress
    rfcData.dcmActWeight = dcmActWeight
    rfcData.intPaymentTypeID = intPaymentTypeID
    rfcData.intPartyID = intPartyID
    rfcData.intIsPartySender = intIsPartySender
    let bU = slctdCnsgnmntType?.BillingUnit
    if (ParentCompanyID === 10 && IsSharedChildCompany === 0 && slctdCnsgnmntType?.IsKgKm === 1) {
      bU = UNIT_BILLED
    }
    cargoGetRateForConsignment(rfcData, slctdRwData, slctdRowIndex, wtCharge, bU, true)
  }
  const hndlCnsgnmntSectChange = (e, index, key) => {
    const val = e.target.value
    if (key == `Quantity` ? val.match(/^\d*$/) : val.match(/^\d*\.?\d*$/)) {
      if (['Quantity', 'Freight'].includes(key) && companySettings?.IsLimitOnUnitAndFreight) {
        const totalCnt = ValidateUnitAndFreightTotal(val, index, key, key == `Freight`)
        if (key == 'Quantity' && totalCnt > companySettings?.NoOfUnits)
          return handleAlert('Total unit should be lessthan ' + companySettings?.NoOfUnits, iid.unit + index)

        if (key == 'Freight' && totalCnt > companySettings?.NoOfFreight)
          return handleAlert('Total freight should be lessthan ' + companySettings?.NoOfFreight, iid.freight + index)
      }
      if (key == `ActualWeight`) {
        //callRFC({ ...ModifyData[index], ActualWeight: val }, index)
        hndlCnsgnmntRate(SelectedConsignment, { ...ModifyData[index], ActualWeight: val }, index)
        calNupdateWtCharge({ ...ModifyData[index], ActualWeight: val }, index)
      }
      if ([`Quantity`, `Rate`].includes(key)) calNupdateWtCharge({ ...ModifyData[index], [key]: val }, index)
      if (key == `Rate`) {
        if (loginData?.IsAdmin != 1) {
          const diff = ModifyData[index].Rate - val
          const AllowFareChange = roleRights?.Table1[0]?.AllowFareChange
          const LimitOnFareChange = roleRights?.Table1[0]?.LimitOnFareChange
          const LimitOnFareChangePer = roleRights?.Table1[0]?.LimitOnFareChangePer
          if (diff > 0) {
            if (AllowFareChange == 0) {
              handleAlert('Insufficient Rights: Fare change is not allowed above ' + LimitOnFareChange, iid.rate + index)
            } else if (AllowFareChange == 1 && common.selBookingType?.typeId != 3) {
              if (diff > LimitOnFareChange) {
                handleAlert('Insufficient Rights: Fare change is not allowed above' + LimitOnFareChange, iid.rate + index)
              } else if (LimitOnFareChangePer > 0) {
                if (diff > getAllowedFareChangePercValue(val, LimitOnFareChangePer)) {
                  handleAlert('Insufficient Rights: Fare change is not allowed above' + LimitOnFareChangePer + '%', iid.rate + index)
                }
              } else if (common.selBookingType?.typeId != 3) {
                //todo party rate master thing needs to be added
                //todo derive a condition to check STA company;
                const isSTA = false

                if (isSTA) {
                  handleAlert('Rate Entered For Party Booking Does Not Match Assigned Rate!', iid.rate + index)
                } else {
                  handleAlert('Rate Entered For Party Booking Does Not Match Assigned Rate!', iid.rate.index)
                }
              }
            }
          }
        }
      }
      if (key == `Freight`) {
        let bU = ModifyData[index]?.slctdCnsgnmntType?.BillingUnit
        let IsSharedChildCompany = 0
        const branchPermisson = companyBookingPermission?.Table1.filter(
          (el) => el.ParentCompanyID === ParentCompanyID && el.ChildCompanyID === loginData?.intCompanyID
        )
        if (branchPermisson.length) IsSharedChildCompany = branchPermisson[0].IsSharedChildCompany
        if (ParentCompanyID === 10 && IsSharedChildCompany === 0 && slctdRwData?.slctdCnsgnmntType?.IsKgKm === 1) {
          bU = UNIT_BILLED
        }
        //billing unit bU 1 is weight billed. 2 is unit billed.
        let newRate = 0

        if (bU == WEIGHT_BILLED) {
          if (ModifyData[index].ChargedWeight > 0) {
            newRate = val / ModifyData[index].ChargedWeight
          }
        } else {
          if (ModifyData[index].Quantity > 0) {
            newRate = val / ModifyData[index].Quantity
          }
        }
        newRate = Number.isInteger(newRate) ? newRate : newRate.toFixed(2)
        updateModifyData(index, 'Rate', newRate)
      }
      updateModifyData(index, key, val)
    }
  }
  const preIdromRate = (disableVlm, disableChargedWeight, i) => {
    if (!disableChargedWeight) {
      return iid.weightCharged + i
    } else if (!disableVlm) {
      return iid.weightVolume + i
    } else {
      return iid.weightActual + i
    }
  }
  const nextidfromWeightvl = (disableChargedWeight, i) => {
    if (!disableChargedWeight) {
      return iid.weightCharged + i
    } else {
      return iid.rate + i
    }
  }
  const nextidfromWeight = (disableVlm, disableChargedWeight, i) => {
    if (!disableVlm) {
      return iid.weightVolume + i
    } else if (!disableChargedWeight) {
      return iid.weightCharged + i
    } else {
      return iid.rate + i
    }
  }
  const cnsgnmntUI = (row, i, lastIndex = false) => {
    const isVlmtrc =
      row?.slctdCnsgnmntType === undefined ||
      row?.slctdCnsgnmntType?.IsVolumetricWeight === undefined ||
      row?.slctdCnsgnmntType?.IsVolumetricWeight === 1
    const disableVlm = !companySettings?.IsWeight || !isVlmtrc
    const disableChargedWeight = companySettings?.IsSTACompany || disableVlm
    return (
      <TableRow key={`datasasa_${i}`}>
        <TableCell>
          <DropDownOA
            id={iid.consignmentType + i}
            // type={SEL_CONSIGNMENT_TYPE}
            defaultvalue={row?.SubType}
            data={cnsgnmntTypes || []}
            width="100%"
            searchPlaceholder={'Search Consignment Type'}
            label={``}
            portal={true}
            isObjArr={true}
            slctdRowData={row}
            slctdRowIndex={i}
            dataKey={`SubType`}
            idKey={`ConsignmentSubTypeID`}
            autoFocus={i === 0}
            onSelect={(e) => {
              //function call for get rate for consignment
              hndlCnsgnmntRate(e, row, i, true)
              setSelectedConsignment(e)
              updateModifyData(i, 'ConsignmentSubTypeID', e.ConsignmentSubTypeID, cnsgnmntTypes)
            }}
            nextId={iid.description + i}
            prevId={i === 0 ? 'receiver-tab-1' : iid.freight + (i - 1)}
          />
        </TableCell>
        <TableCell>
          <div className={'input--wrapper'}>
            <LineInputV2
              id={iid.description + i}
              type="text"
              name="Description"
              label="Write Description"
              value={row?.Description}
              onBlur={(e) => {
                e.target.value != '' ? updateModifyData(i, 'Description', e.target.value) : updateModifyData(i, 'Description', '')
              }}
              filter={getText}
              disabled={!companySettings?.IsDescription}
              onKeyDown={(e) => navigation1(e, iid.packMethod + i, iid.consignmentType + i)}
            />
          </div>
        </TableCell>
        <TableCell>
          <DropDownOA
            id={iid.packMethod + i}
            defaultvalue={row?.mop}
            data={methodOfPckgTypes || []}
            width="100%"
            searchPlaceholder={'Search Pack Method'}
            label={``}
            portal={true}
            disabled={
              !companySettings?.IsMOP ||
              (row?.slctdCnsgnmntType !== undefined &&
                row?.slctdCnsgnmntType?.IsMOPEditable !== undefined &&
                row?.slctdCnsgnmntType.IsMOPEditable == 0)
            }
            isObjArr={true}
            slctdRowData={row}
            slctdRowIndex={i}
            dataKey={`MOPName`}
            idKey={`MOPID`}
            nextId={iid.unit + i}
            prevId={iid.description + i}
            onSelect={(e) => {
              updateModifyData(i, 'Mopid', e.MOPID)
            }}
          />
        </TableCell>
        <TableCell>
          <div className={'input--wrapper'}>
            <LineInputV2
              id={iid.unit + i}
              type="number"
              name="Quantity"
              value={row?.Quantity}
              onBlur={(e) => hndlCnsgnmntSectChange(e, i, 'Quantity')}
              filter={getInt}
              onKeyDown={(e) => navigation1(e, iid.goodsValue + i, iid.packMethod + i)}
            />
          </div>
        </TableCell>
        <TableCell>
          <div className={'input--wrapper'}>
            <LineInputV2
              id={iid.goodsValue + i}
              type="text"
              name="GoodsValue"
              value={row?.GoodsValue}
              filter={getFloat}
              onBlur={(e) => hndlCnsgnmntSectChange(e, i, 'GoodsValue')}
              disabled={!companySettings?.IsGoodsValue}
              onKeyDown={(e) => navigation1(e, iid.weightActual + i, iid.unit + i)}
            />
          </div>
        </TableCell>
        <TableCell>
          <div className={'input--wrapper'}>
            <LineInputV2
              id={iid.weightActual + i}
              type="text"
              name="ActualWeight"
              value={row?.ActualWeight}
              onBlur={(e) => {
                hndlCnsgnmntSectChange(e, i, 'ActualWeight', row)
              }}
              slctdRowData={row}
              slctdRowIndex={i}
              filter={getFloat}
              disabled={!companySettings?.IsWeight}
              onKeyDown={(e) => navigation1(e, nextidfromWeight(disableVlm, disableChargedWeight, i), iid.goodsValue + i)}
            />
          </div>
        </TableCell>
        <TableCell>
          <div className={'input--wrapper'}>
            <LineInputV2
              id={iid.weightVolume + i}
              type="text"
              name="Volume"
              value={disableVlm ? '' : row?.Volume}
              filter={getInt}
              onFocus={() => {
                if (!disableVlm) {
                  setSlctdRwData(row)
                  setSelectedRowIndex(i)
                  //setSelectedRowIndexIsLast(lastIndex)
                  // updateModal(true, `vlmtrcWtUi`)
                  setVolumetriModal(true)
                }
              }}
              disabled={disableVlm}
              onKeyDown={(e) => navigation1(e, nextidfromWeightvl(disableChargedWeight, i), iid.weightActual + i)}
            />
          </div>
        </TableCell>
        <TableCell>
          <div className={'input--wrapper'}>
            <LineInput
              id={iid.weightCharged + i}
              type="text"
              name="ChargedWeight"
              value={row?.ChargedWeight}
              onChange={(e) => hndlCnsgnmntSectChange(e, i, 'ChargedWeight')}
              disabled={disableChargedWeight}
              onKeyDown={(e) => navigation1(e, iid.rate + i, iid.weightVolume + i)}
            />
          </div>
        </TableCell>
        <TableCell>
          <div className={'input--wrapper'}>
            <LineInput
              id={iid.rate + i}
              type="text"
              name="Rate"
              value={row?.Rate}
              onChange={(e) => hndlCnsgnmntSectChange(e, i, 'Rate')}
              onKeyDown={(e) => navigation1(e, iid.freight + i, preIdromRate(disableVlm, disableChargedWeight, i))}
            />
          </div>
        </TableCell>
        <TableCell>
          <div className={'input--wrapper'}>
            <LineInput
              id={iid.freight + i}
              type="text"
              name="Freight"
              value={row?.Freight}
              onChange={(e) => hndlCnsgnmntSectChange(e, i, 'Freight')}
              disabled={!companySettings?.IsFreight}
              // onKeyDown={(e) => navigation1(e, iid.addRemove + i, iid.rate + i)}
              onKeyDown={(e) => navigation1(e, lastIndex ? 'freight' : iid.consignmentType + (i + 1), iid.rate + i)}
            />
          </div>
        </TableCell>
        {/* {IsMultipleConsignment && (
          <TableCell>
            <button
              onKeyDown={(e) =>
                addRemoveKeydownForAdminUpdate(
                  e,
                  lastIndex ? 'coll_Cartage' : iid.consignmentType + (i + 1),
                  iid.freight + i,
                  i,
                  lastIndex,
                  // updateModal,
                  setRemoveIndex,
                  setAddPopup,
                  setDelPopup,
                  calTotalFreight
                )
              }
              id={iid.addRemove + i}
              style={{ display: 'flex', alignItems: 'center' }}
              onClick={
                lastIndex
                  ? () => setAddPopup(true)
                  : () => {
                      setRemoveIndex(i)
                      setDelPopup(true)
                      calTotalFreight(0, i)
                    }
              }
              disabled
            >
              <img
                src={lastIndex ? plusLogo : minusLogo}
                alt=""
                style={{
                  height: '20px',
                  width: '20px',
                  fill: '#0086ff',
                  marginRight: '10px',
                }}
              />
              <span className="blue-color-txt" style={{ textDecoration: 'underline', fontWeight: 'bold' }}>
                {lastIndex ? 'Add' : 'Remove'}
              </span>
            </button>
          </TableCell>
        )} */}
      </TableRow>
    )
  }

  return (
    <>
      <div style={{ width: '100%' }}>
        <div className="booking--line--input--wrappers" style={{ display: 'flex', width: '100%' }}>
          <div style={{ width: '100%', display: 'flex', margin: '0 10px' }}>
            <div className="booking--line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className={'input--wrapper'}>
                    <LineInput className="input-lable" type="text" label={`LR No.`} value={selectLr.LRNo} disabled={true} />
                  </div>
                </Item>
              </Box>
            </div>

            <div className="booking--line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className={'input--wrapper'}>
                    <LineInput
                      className="input-lable"
                      type="text"
                      label={`Manul LR Number`}
                      value={selectLr.ManualLRNo ? selectLr.ManualLRNo : '-'}
                      disabled={true}
                    />
                  </div>
                </Item>
              </Box>
            </div>
            <div className="booking--line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className={'input--wrapper'}>
                    <LineInput className="input-lable" type="text" label={`Payment Type`} value={selectLr.PaymentType} disabled={true} />
                  </div>
                </Item>
              </Box>
            </div>
            <div className="booking--line--input--contents">
              <Box>
                <Item sx={{ background: '#f1f1f5', padding: 0, marginLeft: '10px' }}>
                  <div className={'input--wrapper'}>
                    <LineInput className="input-lable" type="text" label={`Challan Number`} value={selectLr?.VoucherNo} disabled={true} />
                  </div>
                </Item>
              </Box>
            </div>
          </div>
        </div>
        <Box sx={{ display: 'flex', width: '100%', padding: '10px 30px' }} className={`consignments_section`}>
          <TableContainer component={Paper}>
            <TableUI aria-label="simple table">
              <TableHead>
                <TableRow>
                  {cnsgnmntSection.map(
                    ({ width, label, sF }, index) =>
                      sF && (
                        <TableCell key={`cnsgnmntSect_${index}`} style={{ width }}>
                          {label}
                        </TableCell>
                      )
                  )}
                </TableRow>
              </TableHead>
              <TableBody>{ModifyData.map((row, index, { length }) => cnsgnmntUI(row, index, index + 1 === length))}</TableBody>
            </TableUI>
          </TableContainer>
        </Box>
        <div className="akash">
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              padding: '0px 26px',
              alignItems: 'center',
              marginBottom: '10px',
              boxshadow: '0 1px 3px #ddd',
              border: '1px solid gray',
              padding: '10px 11px 10px 18px',
            }}
          >
            {priceSecList?.map((data, i, { length }) => getPriceSectUI(data, i, i + 1 === length))}
            <Item sx={{ width: '8%', marginLeft: '2px', paddingTop: '13px', paddingBottom: '13px' }} className={`Del_Grs_amt`}>
              <div style={{ background: '#00ff72 !important' }}>Gross Amt</div>
              {/* <div>{grossTotal ? grossTotal : 0}</div> */}
              <div>{priceSectionData?.gross_amount?.toFixed(2)}</div>
            </Item>
          </Box>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', textAlign: 'right', justifyContent: 'space-between', padding: '0px 15px' }}>
          <Box sx={{ width: '50%', display: 'flex', gap: '20px', justifyContent: 'space-between', padding: '0px', paddingRight: '10px' }}>
            <div
              className={'input--wrapper'}
              style={{
                width: '100%',
                marginRight: '0px',
              }}
            >
              <LineInputV2
                id={'Cartage Remark'}
                label={'Cartage Remark'}
                type="tel"
                name="ccr_lp"
                value={CCR}
                onBlur={(e) => handleChange(e, 'CCR')}
                sx={{ margin: '8px', width: '100%' }}
                // onKeyDown={(e) => {
                //   navigation1(
                //     e,
                //     nextID(visibleInputIds, iid.cCartageRemark, '', iid.bookCargo),
                //     priceSectIds[priceSectIds.length - 1] || lastCnsngnInput.current
                //   )
                // }}
                disabled={false}
                color={true}
              />
            </div>
            <div
              className={'input--wrapper'}
              style={{
                width: '100%',
                marginRight: '0px',
              }}
            >
              <LineInput
                id={'Comment'}
                label={`Comment`}
                type="text"
                name="cmnt"
                value={cmnt}
                onChange={(e) => handleChange(e, 'cmnt')}
                sx={{ margin: '8px', width: '100%' }}
                // onKeyDown={(e) =>
                //   navigation1(
                //     e,
                //     nextID(visibleInputIds, iid.comment, '', iid.bookCargo),
                //     prevID(visibleInputIds, iid.comment, '', priceSectIds[priceSectIds.length - 1] || lastCnsngnInput.current)
                //   )
                // }
                disabled={false}
                color={true}
              />
            </div>
            {['DESTINATION RECEIVED', 'DELIVERY RECEIVED'].includes((selectLr?.Status+"").toUpperCase()) ? (
              <div
                className={'input--wrapper'}
                style={{
                  width: '100%',
                  marginRight: '0px',
                }}
              >
                <DropDownOA
                  defaultvalue={selectedMethod?.ModeName || ''}
                  onSelect={(value) => {
                    setSelectedMethod(value)
                  }}
                  label={'Method Of Payment'}
                  dataKey={`ModeName`}
                  idKey={`ModeID`}
                  data={methodOfPaymentData || []}
                />
              </div>
            ) : (
              ''
            )}
          </Box>

          {cargoSettingFilterData?.[0]?.IsConvCharge === 1 ? (
            <Item sx={{ width: '10%' }} className={'input--wrapper'}>
              <LineInputV2
                label={'Conv. Chrg'}
                type="text"
                name="Conv_Chrg"
                value={additionalChrg}
                onBlur={(e) => setAdditionalChrg(e.target.value)}
              />
            </Item>
          ) : (
            ''
          )}
          <Box sx={{ width: '30%', display: 'flex', gap: '5px', justifyContent: 'flex-end' }}>
            <Item sx={{ background: '#fff', border: '1px solid #f15a22', textAlign: 'center', margin: '10px', height: '47px' }}>
              <Button
                variant="outlined"
                sx={{ width: '10%', height: '-webkit-fill-available' }}
                style={{ borderColor: '#fff', color: '#f15a22', fontSize: '15px', fontWeight: 'bold', textTransform: 'Uppercase' }}
                onClick={() => updateModal()}
                //   disabled={cancelEdit == true ? true : false}
              >
                {' '}
                CANCEL
              </Button>
            </Item>
            <Item
              sx={{
                // width: '10%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '0px',
                padding: '0',
                //   backgroundColor: '#f0fcf4',
              }}
            >
              <Button
                id={`updateConsignmentBookingCharge`}
                variant="contained"
                className="btn btn-primary"
                autoFocus={false}
                onClick={(e) => {
                  UpdateBookingDeliveryCharges()
                }}
                sx={{
                  width: '100%',
                  padding: '10px',
                  letterSpacing: '2px',
                }}
                //   onKeyDown={(e) => handleIdSaveButton(e, '', iid.comment)}
              >
                UPDATE
              </Button>
            </Item>
          </Box>
        </div>
      </div>
      {addPopup && <ShowConsignmentAddPopUp />}
      {delPopup && <ShowConsignmentDeletePopUp />}
      {collCartageModal && <CollCartageUI inputRef={collCartageRef} setCollCartageModal={setCollCartageModal} callFromAdmin={true} />}
      {volumetriModal && (
        <VolumetricWeightUI
          selectedRowIndex={selectedRowIndex}
          updateModal={updateModal}
          inputRef={VolumetricRef}
          slctdRwData={slctdRwData}
          setSlctdRwData={setSlctdRwData}
          calNupdateWtCharge={calNupdateWtCharge}
          callFromAdmin={true}
          setVolumetriModal={setVolumetriModal}
          updateModifyData={updateModifyData}
        />
      )}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  updateModal,
  updatePriceSectData,
  BookingDeliveryDetailsUpdate,
  ConsignmentBookingChargesUpdate,
  cargoGetRateForConsignment,
  addNewRowModify,
  RemoveRowModify,
  updateModifyData,
  updateAlert,
  updatePriceSectionRowData,
  getCargoSettingFilterData,
  GetMOFPaymentUpdate
}
export default connect(mapStateToProps, mapDispatchToProps)(ConsignmentBookingTab)
